import React from "react";
import mailPreferencesIcon from "../../../assets/test-new/mailPreferencesIcon.svg";
import "./TopButtons.css";
import { Button } from "react-bootstrap";
import ReactTooltip from 'react-tooltip';

const MailPreferenceButton = ({ hidden, onClick, variant }) => {
  return (
    <>
      <Button
        className="top-buttons-frame"
        onClick={onClick}
        variant={variant}
        data-tip="Mail Preferences"
        data-for="mail-preferences-tooltip"
        hidden={hidden}
      >
        <img
          className="material-symbols"
          alt="Mail Preferences"
          src={mailPreferencesIcon}
        />
      </Button>

      <ReactTooltip id="mail-preferences-tooltip" place="top" effect="solid" />
    </>
  );
};

export default MailPreferenceButton;
